import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';

// Neutral catch-all for the patient app. Patients always arrive via a specific
// link (questionnaire token, schedule uuid, ...). Any other/unknown URL lands
// here instead of the therapist login.
const PatientLandingPage: React.FC = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="100vh"
    bgcolor="background.default"
  >
    <Container maxWidth="sm">
      <Paper elevation={0} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          Nothing to see here
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Please use the link that was sent to you to continue.
        </Typography>
      </Paper>
    </Container>
  </Box>
);

export default PatientLandingPage;
